import React, { useState } from "react";
import {
  Row,
  Column,
  FormGroup,
  Button,
  FileUploader,
  TextInput,
  TextArea,
} from "carbon-components-react";
import useGet from "../../hooks/useGet";
import DynamicCheckbox from "../Checkboxes/DynamicCheckbox";
import {
  isCandidatureOptionChecked,
  updateCheckedOptions,
} from "../../services/Utils";
import { useEffect } from "react";

const ProjectDetailsForm = ({ disabled, register, errors, candidature }) => {
  useEffect(() => {}, [candidature]);

  return (
    <FormGroup legendText="DADOS SOBRE O PROJECTO" className="section-header">
      <fieldset className="bx--fieldset">
        <Row>
          <Column xml={12} sm={12} md={12} lg={12} className="required">
            <TextInput
              labelText="6. Qual é o nome do seu projeto?"
              id="projectName"
              name="projectName"
              maxLength={250}
              disabled={disabled}
              {...register("projectName")}
            />
            <p className="field-error">{errors.projectName?.message}</p>
          </Column>
        </Row>
        <Row>
          <Column xml={12} sm={12} md={12} lg={12} className="required">
            <TextArea
              labelText="6.1. Quais são os objetivos do projeto?"
              id="projectObjectives"
              name="projectObjectives"
              rows={5}
              maxLength={1000}
              disabled={disabled}
              {...register("projectObjectives")}
            />
            <p className="field-error">{errors.projectObjectives?.message}</p>
          </Column>
        </Row>
        <Row>
          <Column xml={12} sm={12} md={12} lg={12} className="required">
            <TextArea
              labelText="6.2. Qual é o conteúdo do projeto?"
              id="projectContent"
              name="projectContent"
              rows={5}
              maxLength={1000}
              disabled={disabled}
              {...register("projectContent")}
            />
            <p className="field-error">{errors.projectContent?.message}</p>
          </Column>
        </Row>
        <Row>
          <Column xml={12} sm={12} md={12} lg={12} className="">
            <TextArea
              labelText="6.3. Qual é o perfil de clientes-alvo?"
              id="targetClientProfile"
              name="targetClientProfile"
              rows={5}
              maxLength={1000}
              disabled={disabled}
              {...register("targetClientProfile")}
            />
            <p className="field-error">{errors.targetClientProfile?.message}</p>
          </Column>
        </Row>
        <Row>
          <Column xml={12} sm={12} md={12} lg={12} className="required">
            <TextArea
              labelText="6.4. Quais são as metas do seu projeto?"
              id="projectGoals"
              name="projectGoals"
              // rows={5}
              maxLength={2000}
              disabled={disabled}
              {...register("projectGoals")}
            />
            <p className="field-error">{errors.projectGoals?.message}</p>
          </Column>
        </Row>

        <Row>
          <Column xml={12} sm={12} md={12} lg={12} className="required">
            <TextArea
              labelText="7. Qual é o alinhamento do seu projeto com os objetivos do programa?"
              id="alignmentWithProgramObjectives"
              name="alignmentWithProgramObjectives"
              rows={5}
              maxLength={1000}
              disabled={disabled}
              {...register("alignmentWithProgramObjectives")}
            />
            <p className="field-error">
              {errors.alignmentWithProgramObjectives?.message}
            </p>
          </Column>
        </Row>

        <Row>
          <Column xml={12} sm={8} md={8} lg={8} className="required">
            <TextInput
              labelText="8. Qual é o montante que espera obter do CONECTA para o desenvolvimento da plataforma?"
              id="expectedFundingAmountFromConecta"
              name="expectedFundingAmountFromConecta"
              maxLength={15}
              disabled={disabled}
              {...register("expectedFundingAmountFromConecta")}
            />
            <p className="field-error">
              {errors.expectedFundingAmountFromConecta?.message}
            </p>
          </Column>
        </Row>
      </fieldset>
    </FormGroup>
  );
};

ProjectDetailsForm.defaultProps = {
  disabled: false,
};

export default ProjectDetailsForm;
